import React from "react";

const DigitalHealthSection = ({
  title = "What is",
  highlight = "Digital Health?",
  subtitle = "Connecting people, data, and technology to deliver smarter, more efficient healthcare.",
  description,
  image,
  imageAlt = "Digital Health",
}) => {
  return (
    <section className="py-10 md:py-14 lg:py-18">
      {/* Header */}
      <div className="container mx-auto px-8 md:px-16 lg:px-24 max-w-7xl">
        <div className="text-center mb-4 md:mb-8">
          <h2 className="font-bold mb-4 md:mb-6">
            <span className="">{title} </span>
            <span className="secondary-text">{highlight}</span>
          </h2>

          <p className=" max-w-5xl mx-auto">{subtitle}</p>
        </div>
      </div>

      {/* Content */}
      <div className="grid grid-cols-12">
        {/* Text block */}
        <div className="col-span-12 lg:col-span-6 primary-bg flex items-center justify-center lg:rounded-tl-md lg:rounded-bl-md lg:ml-10 lg:mb-10">
          <p className="text-white p-10 text-left w-full">{description}</p>
        </div>

        {/* Image block */}
        <div className="col-span-12 lg:col-span-6">
          <img
            src={image}
            alt={imageAlt}
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default DigitalHealthSection;
